import type { ReactNode } from "react";

type Props = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  ariaLabel?: string;
  icon?: ReactNode;
};

export function DateField({
  value,
  onChange,
  placeholder = "дд.мм.гггг",
  ariaLabel = "дата",
  icon,
}: Props) {
  return (
    <label className="tp-date-field">
      <input
        type="date"
        className="tp-date-native"
        value={value}
        aria-label={ariaLabel}
        onChange={(event) => onChange(event.target.value)}
      />
      <span className="tp-date-display" data-empty={value ? "false" : "true"}>
        <span className="tp-date-text">
          {formatDateLabel(value) || placeholder}
        </span>
        {icon ? (
          <span className="tp-date-custom-icon" aria-hidden="true">
            {icon}
          </span>
        ) : (
          <span className="tp-date-icon" aria-hidden="true" />
        )}
      </span>
    </label>
  );
}

function formatDateLabel(value: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return value;
  return `${match[3]}.${match[2]}.${match[1]}`;
}
